export default function Contact() {
    const phone = "0509900776";
    const intlPhone = "966509900776";
    const mapsLink =
        "https://maps.google.com?q=G95X+72C%20%D8%AA%D8%B3%D8%A7%D9%84%D9%8A%20%D8%B3%D9%83%D8%A9%2010,%20Al%20Duwadimi%2017441&ftid=0x1586e300175bd1e7:0xb628f1742d0d21be&entry=gps";

    return (
        <div data-testid="contact-page" className="max-w-md mx-auto md:max-w-2xl px-4 py-8">
            <h1 className="section-title text-3xl mb-6">تواصل معنا</h1>

            <div className="space-y-4">
                <a
                    href={`tel:${phone}`}
                    data-testid="contact-call"
                    className="surface-card p-5 flex items-center gap-4 hover:shadow-lg transition"
                >
                    <div className="w-12 h-12 rounded-full bg-brand text-white flex items-center justify-center text-xl">
                        <i className="fa-solid fa-phone" />
                    </div>
                    <div className="flex-1">
                        <div className="font-extrabold text-text-main">اتصل بنا</div>
                        <div className="text-text-muted text-sm" dir="ltr">{phone}</div>
                    </div>
                    <i className="fa-solid fa-arrow-left text-text-muted" />
                </a>

                <a
                    href={`https://wa.me/${intlPhone}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-whatsapp"
                    className="surface-card p-5 flex items-center gap-4 hover:shadow-lg transition"
                >
                    <div className="w-12 h-12 rounded-full bg-whatsapp text-white flex items-center justify-center text-xl">
                        <i className="fa-brands fa-whatsapp" />
                    </div>
                    <div className="flex-1">
                        <div className="font-extrabold text-text-main">راسلنا واتساب</div>
                        <div className="text-text-muted text-sm" dir="ltr">{phone}</div>
                    </div>
                    <i className="fa-solid fa-arrow-left text-text-muted" />
                </a>

                <a
                    href={mapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-location"
                    className="surface-card p-5 flex items-center gap-4 hover:shadow-lg transition"
                >
                    <div className="w-12 h-12 rounded-full bg-[var(--mint)] text-white flex items-center justify-center text-xl">
                        <i className="fa-solid fa-location-dot" />
                    </div>
                    <div className="flex-1">
                        <div className="font-extrabold text-text-main">موقعنا على الخريطة</div>
                        <div className="text-text-muted text-sm">الدوادمي - G95X+72C</div>
                    </div>
                    <i className="fa-solid fa-arrow-left text-text-muted" />
                </a>
            </div>

            <div className="surface-card mt-6 overflow-hidden">
                <iframe
                    title="موقع تسالي سكة 10"
                    src="https://www.google.com/maps?q=24.5095,44.4055&hl=ar&z=15&output=embed"
                    width="100%"
                    height="280"
                    style={{ border: 0 }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>

            <div className="text-center text-text-muted text-sm mt-6">
                <i className="fa-solid fa-clock ms-1" /> ساعات العمل: يومياً من 4 عصراً حتى منتصف الليل
            </div>
        </div>
    );
}
